import styles from './admin-orders-grid.module.scss';
import { CreateHeaders, dateHeader, HeaderSizeEnum, textHeader } from '@frontend-workspace/react-shared-lib';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { IOrders } from '../../_models/orders';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';
import { getOrderStateLabel } from '../../order-state-label';

/* eslint-disable-next-line */
export interface OrdersGridProps {
  orders: IOrders[],
  onDateChange: (dateRange: DateRange<Date> | null) => void,
  dateRange: DateRange<Date>
}

export function OrdersGrid(props: OrdersGridProps) {
  const { t } = useTranslation();
  return (
    <WebkuaTable
      headers={CreateHeaders([
        textHeader("id", "ID", HeaderSizeEnum.MEDIUM),
        dateHeader("activationDate", t("standard.activationDate")),
        textHeader("companyNumber", t("standard.companyNo"), HeaderSizeEnum.SMALL),
        textHeader("contractNumber", t("standard.contractNo"), HeaderSizeEnum.SMALL),
        textHeader("orderType", t("standard.orderType"), HeaderSizeEnum.MEDIUM),
        textHeader("state", "Status", HeaderSizeEnum.MEDIUM, { renderer: params => getOrderStateLabel(params.data, t) }),
        textHeader("errorText", t("standard.errorText"), HeaderSizeEnum.MEDIUM),
        textHeader("changedBy", t("standard.changedBy"), HeaderSizeEnum.MEDIUM)
      ])}
      data={props.orders}
      onSetDateRange={props.onDateChange}
      dateRange={props.dateRange}
    />
  );
}

export default OrdersGrid;